// extracted by mini-css-extract-plugin
export default {"info-box":"FamilyHistoryWrite_info-box__kpPSI","text-list-box":"FamilyHistoryWrite_text-list-box__ZSAkF"};